import { createApp } from "vue";

import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App.vue";
// 引入字体样式
import "./assets/fontFamily/font.css";
import "animate.css";

// 强制浏览器刷新，访问动态路由（/user/manage），进入路由守卫，
router.beforeEach((to) => {
  console.log(to.matched);
  // 动态路由表还未添加，匹配到的是 [] 的路由记录，控制台提示警告，当后继添加完动态路由后正常显示路由视图组件
});
import locale from "element-plus/es/locale/lang/zh-cn";

import kktoast from "./util/notic";

import { detectZoom } from "@/util/detectZoom.js";
const m = detectZoom();
console.log(m, "man.js--m");
// if (window.screen.width * window.devicePixelRatio >= 3840) {
//   document.body.style.zoom = 100 / (Number(m) / 2);
// } else if (
//   window.screen.width * window.devicePixelRatio >= 2560 &&
//   window.screen.width * window.devicePixelRatio <= 3840
// ) {
//   document.body.style.zoom = 100 / (Number(m) / 1.33);
// } else {
//   document.body.style.zoom = 100 / Number(m);
// }
// import store from "./store/index.js";
// if (localStorage.getItem("local_server")) {
//   store.commit("change_url", localStorage.getItem("local_server"));
//   setTimeout(() => {
//     store.commit("inspect_url");
//   }, 1000);
// }

createApp(App)
  .use(router)
  .use(ElementPlus, { locale })
  .use(kktoast)
  .mount("#app");
